module.exports = __webpack_public_path__ + "img/calendar-check.25ed3574.svg";